<footer class="footer">
  <div class="row footer-row">

    <div class="col-lg-5 col-md-12 mb-3 d-flex flex-column align-items-md-end align-items-start">
      <div class="footer-support mb-2">
        <span>Support</span>
        <address class="mb-0">
          <a href="mailto:contact@clorentfactory.com">contact&#64;clorentfactory.com</a><br>
          <a href="tel:+917775028877">(+91) 7775028877</a><br>
          <a>📍 
            SR NO 15/1, WING- C3, BRAHMA MAJESTIC, OFFICE NO 204, 2, NIBM Rd,<br> Kondhwa, Pune, Maharashtra 411048</a>

        </address>
      </div>
      <div class="footer-policy mb-2" (click)="policy()">
        <u>Policy And Privacy</u>
      </div>
      <div class="footer-policy mb-2" (click)="terms()">
        <u>Terms and Conditions</u>
      </div>
      <div class="footer-copyright">
        Copyright &#169;2023 CloRent Factory Pvt. Ltd. All Rights Reserved
      </div>
      <div class="footer-copyright">
        Powered by Intercity Broker.
      </div>
    </div>

    <div class="col-lg-1 d-none d-lg-block">
      <hr>
    </div>
  <div class="col-lg-6 col-md-12 pt-lg-3 pt-2">

  <form id="contact-form" role="form" autocomplete="off">

        <div class="controls">
          <h3>Drop Us a Message</h3>
          <div class="row">
            <div class="col-12 col-md-6 mb-2">
              <div class="form-group">
                <input id="form_name" type="text" name="name" class="form-control"
                  placeholder="Please enter your Full Name *" required data-error="Firstname is required.">
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <div class="form-group">
                <input id="form_email" type="email" name="email" class="form-control"
                  placeholder="Please enter your email *" required data-error="Valid email is required.">
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="form-group">
                <textarea id="form_message" name="message" class="form-control" placeholder="Write your message here."
                  rows="2" required data-error="Please, leave us a message."></textarea>
              </div>
            </div>
            <div class="col-12 text-end">
              <input type="submit" class="btn btn-success btn-send pt-2 px-4" value="Send Message" (click)="submit()">
            </div>
          </div>
        </div>
      </form>
      <div>

      </div>
    </div>
  </div>
</footer>